import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import Modal from '../../../components/modal/modal';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/core/lib/styles/index.css';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';

interface SignatureModalProps {
  isOpen: boolean;
  file: any;
  onClose: Function;
  onAccept: Function;
}

const SignatureModal: React.FC<SignatureModalProps> = ({ isOpen, file, onClose, onAccept }) => {
  const zoomPluginInstance = zoomPlugin();
  const pageNavPluginInstance = pageNavigationPlugin();

  const { ZoomInButton, ZoomOutButton } = zoomPluginInstance;
  const { GoToNextPage, GoToPreviousPage } = pageNavPluginInstance;

  const renderContent = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Este es el contrato que vas a enviar por Signatura. Asegurate de que todos los datos sean correctos.
        </P>
        <Card margin={{ top: '3' }} height='400px'>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
              fileUrl={file}
              plugins={[zoomPluginInstance, pageNavPluginInstance]}
              defaultScale={1}
            />
          </Worker>
        </Card>
        <Card display='flex' justifyContent='center' gap='8px' variant='neutral' borderRadius={false} spacing="2">
          <GoToPreviousPage>
            {(props) => (
              <Button onClick={props.onClick} size='sm' variant='neutral'>
                <Icon name="chevron_left" variant='neutral' height={20} />
              </Button>
            )}
          </GoToPreviousPage>
          <GoToNextPage>
            {(props) => (
              <Button onClick={props.onClick} size='sm' variant='neutral'>
                <Icon name="chevron_right" variant='neutral' height={20} cursor='pointer' />
              </Button>
            )}
          </GoToNextPage>
          <ZoomOutButton />
          <ZoomInButton />
        </Card>
      </Card>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      title={'Confirmar archivo'}
      primaryText='Enviar por signatura'
      primaryVariant='primary'
      secondaryText='Cancelar'
      secondaryVariant='secondary'
      onSecondaryAction={onClose}
      onClose={onClose}
      onPrimaryAction={onAccept}
      children={renderContent()}
      width='800px'
    />
  );
};

export default SignatureModal;